import React from 'react';
import './Director.css';
import DirectorVideo from '../../../assets/Gallery/directorVideo.mp4'; // Corrected file extension to .mp4

function Director() {
    return (
        <div className='director-outer d-flex justify-content-center align-items-center w-100'>
            <div className="director-inner d-flex justify-content-center align-items-center w-100">
                <div className="director-left d-flex justify-content-center align-items-center flex-column w-50">
                    <h2 className="header-text text-align-left">About The Director</h2>
                    <p className="secondary-paragraph-text">
                        Mr. Lalit Baraily, the visionary behind LIMS, brings over two decades of experience in the hospitality and education sector. His unwavering commitment to quality training, global standards, and student success has shaped LIMS into one of the most trusted hotel management institutes in North Bengal. Under his leadership, the institute has maintained a 100% placement record and continues to produce industry-ready professionals equipped to thrive in top hotels and cruise lines worldwide.
                    </p>
                </div>
                <div className="director-right w-50">
                    <video src={DirectorVideo} autoPlay loop />
                </div>
            </div>
        </div>
    );
}

export default Director;
